export enum Permissions {
    AddPageAdditions = 'addPageAdditions',
    AddSlides = 'addSlides',
    AssignmentDetails = 'assignmentDetails',
    AssignmentMeta = 'assignmentMeta',
    CloneAssignment = 'cloneAssignment',
    CopyAssignment = 'copyAssignment',
    DeleteAssignment = 'deleteAssignment',
    DeleteSlides = 'deleteSlides',
    EditAbbreviation = 'editAbbreviation',
    EditAffiliatesState = 'editAffiliatesState',
    EditArticleTaxonomies = 'editArticleTaxonomies',
    EditDueDate = 'editDueDate',
    EditGlobalBannedWords = 'editGlobalBannedWords',
    EditGlobalDisclosures = 'editGlobalDisclosures',
    EditGlobalTaxonomies = 'editGlobalTaxonomies',
    EditGlobalTechniques = 'editGlobalTechniques',
    EditIntroWordCount = 'editIntroWordCount',
    EditMetaDescription = 'editMetaDescription',
    EditMetaImage = 'editMetaImage',
    EditMetaTitle = 'editMetaDescription',
    EditMSNFields = 'editMSNFields',
    EditN2SState = 'editN2SState',
    EditNarrativeState = 'editNarrativeState',
    EditOutroWordCount = 'editOutroWordCount',
    EditPriority = 'editPriority',
    EditQuizType = 'editQuizType',
    EditReferences = 'editReferences',
    EditSiteVerticals = 'editSiteVerticals',
    EditSlideCount = 'editSlideCount',
    EditSlideWordCount = 'editSlideWordCount',
    EditTags = 'editTags',
    EditTargetPublishDate = 'editTargetPublishDate',
    HideOnPage = 'hideOnPage',
    PublishAssignment = 'publish',
    SubmitAssignment = 'submit',
    UpdateAssignment = 'updateAssignment',
    UseSlideAi = 'useSlideAi',
    UseAiPrompt = 'useAiPrompt',
}
